<template>
    <div class="design-container">
       <a-button  v-show="isView" class="design-btn" type="primary" @click="saveTabs">保存</a-button>
        <a-popconfirm
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            title="返回将舍弃所有变更"
            ok-text="是"
            cancel-text="否"
            @confirm="handlepopConfirmConfirm(row)"
            @cancel="handlepopConfirmCancel(row)"
            id="btnn"
            :visible="visible"
        >
            <a-button class="design-btn1" @click="goBack">返回</a-button>
        </a-popconfirm>

        <a-form-model ref="addForm" :model="formObject" :rules="rules" layout="inline" autocomplete="off" class="form-dataset">
            <a-form-model-item prop="dataSet">
                <a-cascader
                    v-model:value="formObject.dataSet"
                    :options="dataSetList"
                    :show-search="{filterZone: (inputValue, path) =>path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)}"
                    :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                    placeholder="请选择数据库及数据表"
                    style="width: 450px"
                />
            </a-form-model-item>
        </a-form-model>
        <a-tabs
            default-active-key="1"
            :tabBarStyle="{ textAlign: 'center' }"
            @change="onDesignTabChange"
            v-model="activeTab"
        >
            <a-tab-pane class="body-container" key="1" tab="表单设计">
                <div class="formdesign-container">
                    <FormDesign ref="formDesign" :jsonData="jsonData" :fieldModels="fieldModels" :dataSourceSet="dataSetList"></FormDesign>
                </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="流程设计" force-render>
                <div class="formdesign-container" style="border: 1px solid #e0e0e0">
                    <FlowDesign
                        ref="refFlow"
                        :xmlStr="xmlStr"
                        :formFieldArr="formFieldArr"
                        :processName="formName"
                    ></FlowDesign>
                </div>
            </a-tab-pane>
            <a-tab-pane key="3" tab="填报设置">
                <div class="formdesign-container" style="border-top: 1px solid #e0e0e0">
                    <FormConfig ref="formConfig" :formConfig="formConfig"></FormConfig>
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>
<script>
import FormDesign from '@/pages/formAudit/templateMgr/design/FormDesign';
import { addFormDetailDesign, saveAll, getFormDetailDesign } from '@/services/form';
import FormConfig from './design/FormConfig.vue';
import FlowDesign from '@/pages/formAudit/templateMgr/design/FlowDesign';
import { dataSetList, dataMetaList } from '@/api/form/formManageApi.js';

export default {
    components: {
        FormDesign,
        FormConfig,
        FlowDesign
    },
    data() {
        return {
            isView: false,
            activeTab: '1',
            formId: '',
            versionId: '',
            jsonData: {},
            formList: [],
            formConfig: undefined,
            xmlStr: '',
            procDefId: '',
            formFieldArr: [],
            displayFields: [],
            formName: '',
            visible: false,
            dataSetList: [],
            formObject: {
                dataSet: []
            },
            rules: {
                dataSet: [{ required: true, message: '请选择数据库及数据表' }],
            },
            fieldModels: []
        };
    },
    watch: {
        async 'formObject.dataSet'(checkedList) {
            const { formObject } = this;
            console.log('======》',checkedList)
            
            if (_.isEmpty(checkedList)) {
                this.fieldModels = []
                return
            }
            if (checkedList[1]) {
                const res = await dataMetaList({sjjbm: checkedList[1]})
                
                let data = res.data.data
                if (data && data.length > 0) {
                    
                    this.fieldModels = _.map(data, item => {
                        return { fieldId: item.ysjmc, fieldLabel: `${item.bm}[${item.ysjmc}]` }
                    })
                    console.log('====2==》',this.fieldModels)
                } else {
                    this.fieldModels = []
                    return
                }
            }
        }
    },
    methods: {
        saveTabs(val) {
            console.log('saveTabs--', val);
            //表单数据
            // console.log('formConfig',this.$refs.formConfig.getFormConfig())

            const formData = {
                formId: this.formId,
                jsonData: this.$refs.formDesign.handleGetFormJosnSubmit(),
                formList: this.$refs.formDesign.handleGetFormJosnSubmit().list
            };

            //if (this.$refs.refFlow == undefined) return this.$message.error('请先设置流程后保存')

            const flowData = {
                id: this.$refs.refFlow.controlForm.processId,
                name: this.$refs.refFlow.controlForm.processName,
                category: '',
                xml: this.$refs.refFlow.xmlString,
                procDefId: this.procDefId
            };
            //if (this.$refs.formConfig == undefined) return this.$message.error('请先设置表单配置后保存')

            const configData = { useScope: {}, manageScope: {},radioValue: '0' };
            // const configData = new Object()
            if (this.$refs.formConfig != undefined) {
                // configData.useScope.fillType = this.$refs.formConfig.form.fillType;
                // configData.useScope.userList = this.$refs.formConfig.form.selectValue;
                // configData.useScope.organList = this.$refs.formConfig.useOrganDataList;
                //
                // configData.manageScope.fillType = this.$refs.formConfig.formManager.fillType;
                // configData.manageScope.userList = this.$refs.formConfig.formManager.selectValue;
                // configData.manageScope.organList = this.$refs.formConfig.manageOrganDataList;
                //-----------------通用组件----------------
                configData.useScope = this.$refs.formConfig.userGroupList1;
                configData.manageScope = this.$refs.formConfig.userGroupList2;
                configData.radioValue = this.$refs.formConfig.radioValue;
            }

            console.log('formData----', formData);
            console.log('flowData----', flowData);
            console.log('configData--', configData);
            
            this.$refs.addForm.validate(valid => {
                if(valid) {
                    formData.dataSet = this.formObject.dataSet
                    saveAll({ formData, flowData, configData }).then(res => {
                        console.log(res);
                        if (res.data.code == 200) {
                            this.$message.success('保存成功');
                            this.$router.push({
                                path: '/formReview/reviewCenter/templateMgr'
                            });
                        }
                    });
                }
            })
        },
        flowClick(val) {
            console.log(val);
            //this.jsonData =
            this.jsonData = this.$refs.formDesign.handleGetFormJosnSubmit();
            this.formList = this.$refs.formDesign.handleGetFormJosnSubmit().list;
            //this.$refs.formDesign.handleFiledJsonSubmit()
            console.log(this.jsonData, '=================this.jsondata');
            //this.handleGetFormDate()
            if (this.formList.length == 0) {
                // this.$message.error('请编辑表单后在制定流程')
                //
                // setTimeout(() => {
                //   this.current = ['form']
                // }, 1000)
                // return
            } else {
                addFormDetailDesign({
                    formId: this.formId,
                    jsonData: this.jsonData,
                    formList: this.formList
                }).then(res => {
                    console.log(res);
                    if (res.data.code == 200) {
                        this.versionId = res.data.data;
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            }
        },
        handleGetFormDate() {
            // this.$nextTick(() => {
            //   this.$refs.generateForm.getData().then(res => {
            //     console.log(res, 'formData')
            //   })
            // })
        },
        handleGetFormDesign() {
            getFormDetailDesign({
                formId: this.formId
            }).then(res => {
                console.log('getFormDetailDesign-------', res);
                if (res.data.code == 200) {
                    const { formDetailVersion, formConfig, flowData, formName } = res.data.data;
                    this.xmlStr = flowData.xml;
                    this.procDefId = flowData.procDefId;
                    this.jsonData =
                        formDetailVersion &&
                        Object.prototype.hasOwnProperty.call(formDetailVersion, 'formData')
                            ? JSON.parse(formDetailVersion.formData)
                            : {};
                    this.formConfig = formConfig ? formConfig : undefined;
                    this.formName = formName ? formName : '';
                    // 回显数据源与数据集
                    if(formDetailVersion?.sjybm && formDetailVersion?.sjjbm) {
                        this.formObject.dataSet = [formDetailVersion.sjybm, formDetailVersion.sjjbm]
                    } else {
                        this.formObject.dataSet = []
                    }
                }
            });
            console.log(this.jsonData, '=================this.jsondata');
        },
        onDesignTabChange(val) {
            if (val == '2') {
                console.log(val);
                this.jsonData = this.$refs.formDesign.handleGetFormJosnSubmit();
                this.formFieldArr = this.$refs.formDesign.handleGetFormJosnSubmit().list;
                // this.$refs.formDesign.handleFiledJsonSubmit()
                this.displayFields = [];
                this.generateModel(this.formFieldArr);
                this.formFieldArr = this.displayFields;
                console.log(this.jsonData, '=================this.jsondata');
            }
        },
        generateModel(genList) {
            console.log('generateModel', genList);
            const multiTypeList = this.extractFormComponents(genList, ['radio', 'input', 'checkbox', 'number']);
            this.displayFields = multiTypeList
            console.log('displayFields', this.displayFields);
        },
        /**
         * 递归提取表单组件
         * @param {Array} nodes 表单节点数组
         * @param {String} targetType 需要筛选的type，如'radio'、'textarea'
         * @returns {Array} [{model,name,type}]
         */
        extractFormComponents(nodes, targetTypes) {
            const result = [];
                // 统一转为数组，兼容字符串和数组两种入参
                const typeList = Array.isArray(targetTypes) ? targetTypes : [targetTypes];
            
                for (const node of nodes) {
                    // 1.栅格grid布局，遍历columns -> col.list递归
                    if (node.type === 'grid' && Array.isArray(node.columns)) {
                        for (const col of node.columns) {
                            if (Array.isArray(col.list)) {
                                const children = this.extractFormComponents(col.list, typeList);
                                result.push(...children);
                            }
                        }
                    }
                    // 2.inline行内布局，list子组件递归
                    else if (Array.isArray(node.list)) {
                        const children = this.extractFormComponents(node.list, typeList);
                        result.push(...children);
                    }
                    // 3.匹配任意一个目标类型就收集
                    else if (typeList.includes(node.type)) {
                        result.push({
                            model: node.model,
                            name: node.name,
                            type: node.type
                        });
                    }
                }
                return result;
        },
        goBack() {
            this.visible = true;
        },
        handlepopConfirmConfirm() {
            this.$router.go(-1);
        },
        handlepopConfirmCancel() {
            this.visible = false;
        },
        fetchDataSet() {
            // 查询数据源/数据集
            dataSetList().then(res => {
                console.log('===查询数据源/数据集==>',res.data)
                this.dataSetList = res.data.data
            })
        }
    },
    created() {
        //     // const deployId = this.$route.query && this.$route.query.deployId
        //     const deployId = this.deploymentId
        //     //  查询流程xml
        //     if (deployId) {
        //         this.getModelDetail(deployId)
        //     }
        //
        //     /** 查询流程分类 **/
        //     // this.getDicts('sys_process_category').then(res => {
        //     //     this.categorys = res.data
        //     // })
        //
        //     查询办理任务的人员列表
        //     this.getDataList()
        this.formId = this.$route.query && this.$route.query.moduleId;
        // this.isView = this.$route.query.isView;
         this.isView = this.$route.query?.isView === 'true'; 
        console.log(this.isView, 'this.isView');
        this.versionId = '';
        this.handleGetFormDesign();
        console.log(this.jsonData, '=================this.jsondata created');
        this.fetchDataSet();
    }
};
</script>
<style lang="less" scoped>
.design-container {
    height: 100%;
    position: relative;

    .design-btn {
        position: absolute;
        right: 20px;
        top: 6px;
        z-index: 1;
    }

    .design-btn1 {
        position: absolute;
        right: 100px;
        top: 6px;
        z-index: 1;
    }
    
    .form-dataset {
        position: absolute;
        left: 15px;
        top: 2px;
        z-index: 1;
    }

    /deep/ .head {
        // min-height: 120px;
        // background: red;
        .ant-menu {
            display: flex;
            justify-content: center;
            width: 100%;

            .a-menu-item-span {
                width: 200px;
                height: 24px;
                line-height: 24px;
                font-size: 14px;
                padding: 5px 8px;
                // border: 1px solid #ddd;
                background: #fff;
                color: #000;
                border-radius: 50%;
            }

            .active {
                background: #1890ff;
                color: #ddd;
            }
        }
    }

    /deep/ .body-container {
        height: 100%;
    }

    /deep/ .ant-tabs-nav-container {
        background: #fff;
    }

    .formdesign-container {
        width: calc(100% + 2px);
        margin-left: -1px;
        height: calc(100vh - 160px);
    }
}

/deep/ .ant-tabs-bar {
    margin: 0px !important;
}

/deep/ .fm2-container footer {
    display: none !important;
}

/deep/ .my-process-designer {
    background-color: #fff;
}

/deep/ a.bjs-powered-by {
    display: none;
}

/deep/ .ant-popover-buttons {
    text-align: center !important;
}
</style>
